<!-- src/views/pages/crm/pipeline/pipeline-table.vue -->
<script setup>
const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(["edit", "delete"]);

const columns = [
  { sorter: false },
  {
    title: "Pipeline Name",
    dataIndex: "name",
    key: "name",
    sorter: { compare: (a, b) => (a.name || "").localeCompare(b.name || "") },
  },
  {
    title: "Total Deal Value",
    dataIndex: "total_deal_value",
    sorter: {
      compare: (a, b) =>
        Number(a.total_deal_value || 0) - Number(b.total_deal_value || 0),
    },
  },
  {
    title: "No of Deals",
    dataIndex: "deals_count",
    sorter: {
      compare: (a, b) => Number(a.deals_count || 0) - Number(b.deals_count || 0),
    },
  },
  {
    title: "Stages",
    dataIndex: "stages_count",
    key: "stages_count",
    sorter: {
      compare: (a, b) =>
        Number(a.stages_count || 0) - Number(b.stages_count || 0),
    },
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    sorter: {
      compare: (a, b) =>
        new Date(a.created_at || 0) - new Date(b.created_at || 0),
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    sorter: {
      compare: (a, b) => (a.status || "").localeCompare(b.status || ""),
    },
  },
  { title: "", key: "action", sorter: true },
];

function stageProgressClass(count) {
  if (count >= 5) return "bg-success";
  if (count >= 3) return "bg-warning";
  return "bg-danger";
}

function fmtMoney(v) {
  const n = Number(v || 0);
  return isFinite(n) ? n.toLocaleString() : "0";
}
function fmtDate(v) {
  try {
    const d = new Date(v);
    return isNaN(d.getTime()) ? "-" : d.toLocaleDateString();
  } catch {
    return "-";
  }
}

function onEdit(record) {
  emit("edit", record);
}
function onDelete(record) {
  emit("delete", record);
}
</script>

<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="props.rows"
    :loading="props.loading"
    row-key="id"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'name'">
        <h6 class="fs-14 fw-medium">{{ record.name }}</h6>
      </template>

      <template v-else-if="column.dataIndex === 'total_deal_value'">
        {{ fmtMoney(record.total_deal_value) }}
      </template>

      <template v-else-if="column.dataIndex === 'deals_count'">
        {{ record.deals_count || 0 }}
      </template>

      <template v-else-if="column.key === 'stages_count'">
        <div class="d-flex align-items-center">
          <div
            class="progress me-2"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
            style="height: 5px; min-width: 80px"
          >
            <div
              :class="['progress-bar', stageProgressClass(record.stages_count || 0)]"
              style="width: 100%"
            ></div>
          </div>
          <span class="fs-14 fw-normal">{{ record.stages_count || 0 }} stages</span>
        </div>
      </template>

      <template v-else-if="column.dataIndex === 'created_at'">
        {{ fmtDate(record.created_at) }}
      </template>

      <template v-else-if="column.key === 'status'">
        <span
          :class="[
            'badge',
            record.status === 'Active' ? 'badge-success' : 'badge-danger',
            'd-inline-flex','align-items-center','badge-xs'
          ]"
        >
          <i class="ti ti-point-filled me-1"></i>{{ record.status }}
        </span>
      </template>

      <template v-else-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a href="javascript:void(0);" class="me-2" @click.prevent="onEdit(record)" v-can="'Pipeline.Edit'">
            <i class="ti ti-edit"></i>
          </a>
          <a href="javascript:void(0);" @click.prevent="onDelete(record)" v-can="'Pipeline.Delete'">
            <i class="ti ti-trash"></i>
          </a>
        </div>
      </template>
    </template>
  </a-table>
</template>
